import { Box, Typography } from '@mui/material'
import React from 'react'

const CSIntroduction = () => {
  return (
    <Box sx={{
        margin:{xs:"1.2rem 1.2rem 1.2rem 1.2rem ",sm:"4rem"},

    }} >

<Typography
          sx={{
            fontFamily: 'Montserrat',
            fontSize: '1.6rem',
            fontWeight:"500",
            marginTop:"1.2rem",
            

          }}
        >
          <span style={{ color: 'rgba(255, 102, 0, 1)' }}>Case study </span> 
          Name {' '}

        </Typography>

      <Typography sx={{
        fontFamily:"Plus Jakarta Sans",
        fontWeight:"500",
        fontSize:"1.8rem",
        marginTop:"1rem",

      }} >Introduction</Typography>
      <Typography sx={{
                fontFamily:"Plus Jakarta Sans",
                marginTop:"1rem",

                color:"rgba(51, 51, 51, 1)",

      }} >Lorem ipsum dolor sit amet consectetur. Eu semper libero posuere turpis enim mauris est nec. Adipiscing ridiculus erat eleifend blandit faucibus nunc. Condimentum blandit arcu viverra rhoncus eu. Et et sed arcu nulla faucibus id lobortis.</Typography>
      <Typography sx={{
                fontFamily:"Plus Jakarta Sans",
                marginTop:"1rem",
                color:"rgba(51, 51, 51, 1)",

      }} >Lorem ipsum dolor sit amet consectetur. Eu semper libero posuere turpis enim mauris est nec. Adipiscing ridiculus erat eleifend blandit faucibus nunc. Condimentum blandit arcu viverra rhoncus eu. Et et sed arcu nulla faucibus id lobortis.</Typography>
    </Box>
  )
}

export default CSIntroduction
